"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetFieldCompleter = exports.unsetCompleters = exports.setCompleters = exports.getLanguageFromFormat = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactAce = _interopRequireDefault(require("react-ace"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
require("ace-builds");
require("ace-builds/src-noconflict/mode-javascript");
require("ace-builds/src-noconflict/mode-html");
require("ace-builds/src-noconflict/mode-css");
require("ace-builds/src-noconflict/mode-python");
require("ace-builds/src-noconflict/theme-textmate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // https://github.com/securingsincity/react-ace/blob/master/docs/Ace.md
if (process.env.NODE_ENV !== 'test') {
  // skip webpack references when testing to make it easier for jest to find the extension modules
  require('ace-builds/webpack-resolver');
}
/* eslint-disable import/first */

/* eslint-enable import/first */

var langTools = require('ace-builds/src-noconflict/ext-language_tools');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _theme$colors, _theme$variables;
  return _objectSpread(_objectSpread({}, theme), {}, {
    root: {
      // note: this will only be undefined during testing as the full component
      // cannot load in headless unit testing due to dynamic imports limitations in jest.
      border: (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.blueGrey) ? "1px solid ".concat(theme.colors.blueGrey) : '',
      borderRadius: (theme === null || theme === void 0 ? void 0 : (_theme$variables = theme.variables) === null || _theme$variables === void 0 ? void 0 : _theme$variables.borderRadius) || '0.875rem',
      overflow: 'hidden'
    }
  });
});
/*:: type CodeLanguages = 'javascript' | 'html' | 'css' | 'python';*/
var useHiddenStyles = (0, _styles.makeStyles)(function () {
  return {
    hidden: {
      display: 'none'
    }
  };
});
var HiddenInput = function HiddenInput(props /*: { name: string, value: any }*/) {
  var classes = useHiddenStyles();
  // be sure to use textarea as target input to sync value to, since code will predominantly be multi-line
  return /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({}, props, {
    className: classes.hidden,
    readOnly: true
  }));
};
/*:: export type FieldSuggestion = {
  id: string,
  source?: string,
  display: string,
  type: React.Node
};*/
/*:: type Props = {
  className?: string,
  disabled?: boolean,
  /**  this should be a UNIQUE id *-/
  id: string,
  name: string,
  title: string,
  description?: string,
  required?: boolean,
  defaultValue?: any,
  onEditorLoad?: (...args: Array<any>) => any,
  onBlur?: (...args: Array<any>) => any,
  onChange?: ({
    currentTarget: {
      id?: string,
      name?: string,
      required?: boolean,
      value: string
    }
  }) => void,
  onFocus?: (...args: Array<any>) => any,
  title?: string | React.Element<typeof FormattedMessage>,
  type?: string,
  /** language can also be inferred from a `schema: type` *-/
  language?: CodeLanguages,
  /** how high in (pixels or %) to format the editor  *-/
  editorHeight?: string,
  /** how wide in (pixels or %) to format the editor *-/
  editorWidth?: string,
  /** how many lines to display in the editor by default, ignored if there is a value/defaultValue  *-/
  editorMinLines?: number,
  /** whether to enable autocompletion features. default: true *-/
  editorAutoComplete?: boolean,
  /** Data: field reference data for autocompletion *-/
  data: Array<FieldSuggestion>,
  readOnly?: boolean,
  format?: string
};*/
/**
 * Checks whether a format has been passed and has the
 * expected format of `code:<language>`, and whether
 * that language is one of the supported types.
 * Defaults to `javascript`.
 * @returns String type CodeLanguage
 */
var getLanguageFromFormat
/*: (
  format?: string
) => CodeLanguages*/
= exports.getLanguageFromFormat = function getLanguageFromFormat(format) {
  var defaultValue = 'javascript';
  if (!format) {
    return defaultValue;
  }
  var values = format ? format.split(':') : [];
  var languages /*: Array<CodeLanguages>*/ = ['javascript', 'css', 'html', 'python'];
  if ((values === null || values === void 0 ? void 0 : values.length) === 1 || !values[1] || languages.indexOf(values[1]) === -1) {
    return defaultValue;
  }
  return (values[1] /*: any*/);
};

/**
 * Parses a data field list and returns Field Formula-formatted data options.
 * This is specific to Ace editor configuration.
 * @param {Array} data - field data
 */
var useGetFieldCompleter = exports.useGetFieldCompleter = function useGetFieldCompleter(data /*: Array<FieldSuggestion>*/) {
  // $FlowIgnore
  var getCompletions = function getCompletions(editor, session, pos, prefix, callback) {
    // try to guess fields access vs global state
    var completions = data.map(function (field) {
      return {
        name: field.display,
        value: field.id && field.id.includes('.') ? field.id : "fields[\"".concat(field.id, "\"]"),
        caption: "".concat(field.id, ": ").concat(field.display, " ").concat(field.source ? "(".concat(field.source, ")") : ''),
        meta: field.source
      };
    });
    callback(null, completions);
  };
  return React.useCallback(getCompletions, [data]);
};
var setCompleters = exports.setCompleters = function setCompleters(langTools /*: any*/, fieldCompleter /*: Function*/) {
  if (langTools) {
    langTools.setCompleters([{
      exactMatch: true,
      getCompletions: fieldCompleter
    }]);
  }
};
var unsetCompleters = exports.unsetCompleters = function unsetCompleters(langTools /*: any*/) {
  if (langTools) {
    langTools.setCompleters([]);
  }
};
var CodeInput = function CodeInput(_ref /*:: */) {
  var className = _ref /*:: */.className,
    disabled = _ref /*:: */.disabled,
    id = _ref /*:: */.id,
    name = _ref /*:: */.name,
    _ref$onEditorLoad = _ref /*:: */.onEditorLoad,
    onEditorLoad = _ref$onEditorLoad === void 0 ? function () {} : _ref$onEditorLoad,
    onChange = _ref /*:: */.onChange,
    onBlur = _ref /*:: */.onBlur,
    onFocus = _ref /*:: */.onFocus,
    title = _ref /*:: */.title,
    language = _ref /*:: */.language,
    defaultValue = _ref /*:: */.defaultValue,
    _ref$editorHeight = _ref /*:: */.editorHeight,
    editorHeight = _ref$editorHeight === void 0 ? '300px' : _ref$editorHeight,
    _ref$editorWidth = _ref /*:: */.editorWidth,
    editorWidth = _ref$editorWidth === void 0 ? '100%' : _ref$editorWidth,
    _ref$editorAutoComple = _ref /*:: */.editorAutoComplete,
    editorAutoComplete = _ref$editorAutoComple === void 0 ? true : _ref$editorAutoComple,
    _ref$editorMinLines = _ref /*:: */.editorMinLines,
    editorMinLines = _ref$editorMinLines === void 0 ? 5 : _ref$editorMinLines,
    data = _ref /*:: */.data,
    format = _ref /*:: */.format;
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    codeText = _React$useState2[0],
    setCodeText = _React$useState2[1];
  var editor = React.createRef();
  var classes = useStyles();
  var languageType = React.useMemo(function () {
    return language || getLanguageFromFormat(format);
  }, [format, language]);
  var fieldCompleter = useGetFieldCompleter(data);
  var handleEditorLoad = React.useCallback(function () {
    setCompleters(langTools, fieldCompleter);
    onEditorLoad();
  }, [onEditorLoad, fieldCompleter]);
  React.useEffect(function () {
    // unload field-specific completers on unmount
    return function () {
      unsetCompleters(langTools);
    };
  }, []);

  // Sync with HiddenInput until such a time as we have access to an input with the raw text value directly
  // from the AceEditor component.
  var handleChange = function handleChange(newValue) {
    setCodeText(newValue);
    if (typeof onChange === 'function') {
      // Parameter types of an unknown function are unknown
      // (https://github.com/facebook/flow/issues/7702)
      // $FlowIgnore
      onChange({
        currentTarget: {
          id: id,
          name: name,
          value: newValue
        }
      }, newValue);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    title: title,
    "data-id": name,
    "data-testid": 'CodeInput'
  }, /*#__PURE__*/React.createElement(_reactAce.default, {
    ref: editor,
    mode: languageType,
    theme: "textmate",
    className: classes.aceEditor,
    onLoad: handleEditorLoad,
    onBlur: onBlur,
    onChange: handleChange,
    onFocus: onFocus,
    name: id,
    setOptions: {
      enableBasicAutocompletion: editorAutoComplete,
      enableLiveAutocompletion: editorAutoComplete
    },
    readOnly: disabled,
    editorProps: {
      $blockScrolling: true
    },
    height: editorHeight,
    width: editorWidth,
    minLines: editorMinLines,
    defaultValue: defaultValue
  }), /*#__PURE__*/React.createElement(HiddenInput, {
    name: name,
    value: codeText
  }));
};
var _default = exports.default = React.memo(CodeInput);
//# sourceMappingURL=CodeInput.js.map